module.exports = __webpack_public_path__ + "media/images/landing/john-adler-4316af2526ec3712d9e2500ae0944708.jpg";